import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function CGUEN() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation for information purposes only.
          The French version is the sole legally binding version. In case of discrepancy, the French version shall prevail.
        </p>
      </div>
      <LegalSection title="1. Service description">
        <p>Kurso is an AI-powered personalised learning platform. It generates structured courses on any topic using artificial intelligence, and provides interactive quizzes, gamification features (XP, badges, streaks), a community forum, and a mentor marketplace.</p>
      </LegalSection>
      <LegalSection title="2. Subscription plans">
        <ul>
          <li><strong>Explorateur (free):</strong> 20 credits every month, i.e. 1 full AI course per month (6 modules, intro videos with AI voice-over, quizzes), access to public courses, no credit card</li>
          <li><strong>Learner (€6.90/month):</strong> 200 AI credits/month, PDF & PPTX exports, progress tracking</li>
          <li><strong>Créateur Pro (€24.90/month):</strong> 600 AI credits/month, SCORM & xAPI exports, advanced course editor, marketplace access</li>
          <li><strong>Organisation (€69/month):</strong> 2,000 shared AI credits, multi-member management, HR dashboard, all exports</li>
          <li><strong>HR & Workforce (€149/month):</strong> 6,000 shared AI credits, advanced workforce planning, API access, priority support</li>
        </ul>
        <p>A full AI course costs 10 credits. Credits are charged when generation starts and <strong>automatically refunded</strong> if the course does not meet 100% of the quality criteria (intro video, content and quiz for every module) and is not published.</p>
        <p>Subscriptions are monthly, cancel at any time. Payments are processed by Stripe.</p>
      </LegalSection>
      <LegalSection title="3. User obligations">
        <p>By using Kurso, you agree to:</p>
        <ul>
          <li>Provide accurate registration information</li>
          <li>Not share your account credentials</li>
          <li>Use the platform for lawful, educational purposes only</li>
          <li>Respect other users and community members</li>
          <li>Not attempt to circumvent generation limits or technical protections</li>
        </ul>
      </LegalSection>
      <LegalSection title="4. Prohibited content">
        <p>You must not generate, share, or distribute content that is: illegal, violent, discriminatory, pornographic, deceptive, or in violation of third-party intellectual property rights.</p>
        <p>Kurso reserves the right to suspend or delete accounts that violate these terms without prior notice.</p>
      </LegalSection>
      <LegalSection title="5. Intellectual property">
        <p>The Kurso platform, brand, and interface are the exclusive property of SAS Sanctuaire Consulting Services. AI-generated course content is provided to users for personal educational use only — commercial redistribution is prohibited without written authorisation.</p>
      </LegalSection>
      <LegalSection title="6. Termination">
        <p>You may delete your account at any time from your profile settings. Upon deletion, your data will be permanently erased after a 30-day grace period. Active subscriptions are not refunded for the remaining period.</p>
      </LegalSection>
      <LegalSection title="7. Liability">
        <p>Kurso provides its service on a best-efforts basis (99.5% SLA). Kurso is not responsible for service interruptions due to force majeure, maintenance, or third-party provider failures. AI-generated content is provided for educational purposes and may contain errors.</p>
      </LegalSection>
      <LegalSection title="8. Governing law">
        <p>These Terms are governed by French law. Any dispute shall be brought before the competent French courts. The French version of these Terms is the sole legally binding version.</p>
      </LegalSection>
    </LegalLayout>
  );
}
